import { ADD_TO_CART, REMOVE_FROM_CART, CLEAR_CART } from '../actions/types';

const initialState = {
    cartItems: [],
};

export default function(state = initialState, action) {
    switch (action.type) {
        case ADD_TO_CART:
            const newItem = action.payload;
            const existingItemIndex = state.cartItems.findIndex(item => item.id === newItem.id);

            // अगर आइटम पहले से कार्ट में मौजूद है
            if (existingItemIndex > -1) {
                // कार्ट की एक नई कॉपी बनाएं
                const updatedCartItems = [...state.cartItems];
                // उस आइटम को नए आइटम से बदलें (जिसमें अपडेटेड प्लान है)
                updatedCartItems[existingItemIndex] = newItem;
                
                return {
                    ...state,
                    cartItems: updatedCartItems,
                };
            } else {
                // अगर आइटम नया है, तो उसे कार्ट में जोड़ें
                return {
                    ...state,
                    cartItems: [...state.cartItems, newItem],
                };
            }
        
        case REMOVE_FROM_CART:
            return { 
                ...state, 
                cartItems: state.cartItems.filter(item => item.id !== action.payload) 
            };

        case CLEAR_CART:
            return { 
                ...state, 
                cartItems: [] 
            };

        default:
            return state;
    }
}